export default {"src":"/_next/static/media/tick2.b64d9924.svg","height":6,"width":8,"blurWidth":0,"blurHeight":0};